<lib-modal-container class="bootstrap-wrapper" classModalTitle="bg-azul-sunedu" [modalTitle]="'Busca tu key'"
  cancelText="Cerrar" [noActions]="true" (dismiss)="handleClose()">

  <div fxLayout="column" class="m-b-25">
    <div *ngIf="tokenSended" class="text-center">
      <label class="font-bold">Se envió a su correo electrónico la key de acceso.</label>
    </div>
    <div *ngIf="showError" class="text-center">
      <label class="font-bold">No se encuentra registrado, solicite su key.</label>
    </div>
    <div *ngIf="!tokenSended && showError == null" class="text-center">
      <label class="font-bold">¿Te olvidaste tu key?</label>
      <div class="m-t-10">
        <button class="p-l-0" mat-button (click)="handleClickCheckCiudadano()">
          <mat-icon *ngIf="!checkCiudadano">radio_button_unchecked</mat-icon>
          <mat-icon *ngIf="checkCiudadano" class="text-naranja-sunedu">
            radio_button_checked
          </mat-icon>
          Especialista
        </button>

        <button mat-button (click)="handleClickCheckCiudadano()">
          <mat-icon *ngIf="checkCiudadano">radio_button_unchecked</mat-icon>
          <mat-icon *ngIf="!checkCiudadano" class="text-naranja-sunedu">
            radio_button_checked
          </mat-icon>
          Organización
        </button>
      </div>
    </div>
    <div *ngIf="!tokenSended && showError == null" fxFlex="auto" class="text-left">
      <form fxFlex="auto" [formGroup]="form">
        <div *ngIf="checkCiudadano" class="font-bold">Tipo de documento</div>
        <lib-form-control *ngIf="checkCiudadano" appearance="outline" variant="select" bindLabel="label"
          bindValue="name" [formGroupParent]="form" placeholder="Seleccione" controlName="tipoDocumento"
          [options]="tiposDocumentos" label="Tipo de documento">
        </lib-form-control>
        <div *ngIf="checkCiudadano" class="font-bold">Número de documento</div>
        <lib-form-control *ngIf="checkCiudadano" appearance="outline" variant="text" [formGroupParent]="form"
          label="Número de documento" controlName="numeroDocumento" [inputProps]="form.value.tipoDocumento == 'Dni'? {maxlength:8} : {maxlength:15} ">
        </lib-form-control>
        <div class="font-bold">Correo</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Correo"
          controlName="correo" [inputProps]="{maxlength:60}">
        </lib-form-control>
        <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" formControlName="recaptcha">
        </ngx-recaptcha2>
      </form>
    </div>
    <div *ngIf="!tokenSended && showError == null" class="text-center">
      <button (click)="handleEnviar()" [disabled]="loading" mat-flat-button [ngClass]="!loading ? 'bg-azul-sunedu rounded-full m-l-15':'bg-gray-sunedu rounded-full m-l-15'">
        Consultar
      </button>
    </div>
  </div>

</lib-modal-container>